<template>
    <header>
        <nav>
            <h1><router-link to="/">Find a Coach</router-link></h1>
        </nav>
        <nav>
            <ul>
                <li>
                    <router-link to="/coaches">Coach List</router-link>
                </li>
                <li v-if="isLoggedIn"> 
                    <router-link to="/requests">Requests List</router-link>
                </li>
                <li v-else>
                  <router-link to="/auth">Login</router-link>
                </li>
                <li v-if="isLoggedIn">
                  <base-button link @click="logout">Logout</base-button>
                </li>
              
            </ul>
        </nav>
    </header>
</template>

<script>
export default {
  computed:{
    isLoggedIn(){
      return this.$store.getters.isAuthenthicated
    }
  },
  methods : {
    logout(){
      this.$store.dispatch('logout');
    }
  }
}
</script>

<style scoped>
header {
  width: 100%;
  height: 5rem;
  background-color: green;
  display: flex;
  justify-content: center;
  align-items: center;
}

header a {
  color: #f391e3;
  text-decoration: none;
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border: 1px solid transparent;
}

a:active,
a:hover,
a.router-link-active {
  border: 1px solid #f391e3;
}

h1 {
  margin: 0;
}

h1 a {
  color: white;
  margin: 0;
}

h1 a:hover,
h1 a:active,
h1 a.router-link-active {
  border-color: transparent;
}

header nav {
  width: 50%;
  margin: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

header ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

li {
  margin: 0 0.5rem;
}
</style>